import { useBreakpoint } from '@chakra-ui/react'

import {
  ITLIST_DETAILS_PAGE_LG_WIDTH,
  ITLIST_FEATURES_PAGE_LG_WIDTH,
} from 'src/lib/constants'

import Large from './Large/Large'
import Small from './Small/Small'

const Carousel = ({
  children,
  startWithItem,
  smItemWidth,
  smMarginLeft,
  smOuterPadding,
  gapSmMd,
  lgOffsetArrows,
  lgItemsPerRow,
  lgCarouselWidth,
  gapLg,
}: {
  children: React.ReactNode | React.ReactNode[]
  smItemWidth: number
  smMarginLeft?: number
  smOuterPadding?: number
  gapSmMd?: number
  gapLg?: number
  lgOffsetArrows?: number
  lgItemsPerRow: number
  lgCarouselWidth?: number
  startWithItem?: number
}) => {
  const size = useBreakpoint()
  const isSmMd = ['sm', 'md'].includes(size)
  if (size === 'base') return null
  if (lgItemsPerRow !== 2 && lgItemsPerRow !== 3) {
    console.warn(
      `ItListCarousel should have an lgItemsPerRow prop of 2 or 3, found: ${lgItemsPerRow}`
    )
  }
  return isSmMd ? (
    <Small
      gap={gapSmMd}
      itemWidth={smItemWidth}
      startWithItem={startWithItem}
      outerPadding={smOuterPadding}
      margin={smMarginLeft}
    >
      {children}
    </Small>
  ) : (
    <Large
      gap={gapLg}
      itemsPerRow={lgItemsPerRow}
      offsetArrows={lgOffsetArrows}
      width={
        lgCarouselWidth ||
        (lgItemsPerRow === 2
          ? ITLIST_DETAILS_PAGE_LG_WIDTH
          : ITLIST_FEATURES_PAGE_LG_WIDTH)
      }
    >
      {children}
    </Large>
  )
}

export default Carousel
